var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mark-layout"},[_c('div',{staticClass:"h100"},[_c('iframe',{ref:"iframePage",attrs:{"src":_vm.iframeUrl,"frameborder":"0","height":"100%","width":"100%"},on:{"load":function($event){return _vm.onLoad()}}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }